import React from 'react';
import CertificationDaysOpenStatus from './CertificationDaysOpenStatus';

// NVBDC-1406 — extracted from the identical "App ID: X <counter/> {type} – {status}" line
// copy-pasted into every Admin tab's header. certificationType/certificationStatus are omitted
// (no trailing label rendered) on CompanyInfo, which shows that pair separately in its own
// panel-header-actions block.
function AdminAppIdHeader({ appId, daysOpen, certificationType, certificationStatus }) {
	return (
		<React.Fragment>
			App ID: {appId} <CertificationDaysOpenStatus daysOpen={daysOpen} />
			{certificationType && (
				<small style={{ marginTop: '5px' }} className="pull-right">{certificationType} – {certificationStatus}</small>
			)}
		</React.Fragment>
	);
}

export default AdminAppIdHeader;



// WEBPACK FOOTER //
// ./src/areas/shared/components/certificationDaysOpen/AdminAppIdHeader.js